import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { supplierConfig } from './supplierConfig';
import { createSupplierValidationSchema } from './supplierValidation';

/**
 * Initialize the Supplier module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  supplierConfig,
  createSupplierValidationSchema
);

/**
 * Create the SupplierPage using the generic module page factory
 */
const SupplierPage = createModulePage(
  initializedConfig,
  {
    displayName: 'SupplierPage',
    description: 'Supplier Management System - Supplier information and contact management'
  }
);

export default SupplierPage;
